import {
  call, put, select, takeEvery,
} from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import selectors from '@/selectors';
import WorkflowsService from '../service';
import {
  showWorkflow,
  showWorkflowError,
  showWorkflows,
  showWorkflowsError,
} from '../actions';
import actions from '../constants';

export function* workflows(action) {
  const items = yield select(selectors.workflows);
  const { enabledFlag, disabledFlag } = items[action.category];
  const includeEnabled = action.enabledFlag || enabledFlag;
  const includeDisabled = action.disabledFlag || disabledFlag;

  const { response, error } = yield call(callAdapter, WorkflowsService.workflows(includeEnabled, includeDisabled));
  if (error) {
    yield put(showWorkflowsError(action.category, error));
  } else {
    yield put(showWorkflows(action.category, response.items));
  }
}

export function* workflow({ category, code }) {
  const { response, error } = yield call(callAdapter, WorkflowsService.workflow(code));
  if (error) {
    yield put(showWorkflowError(category, code, error));
  } else {
    yield put(showWorkflow(category, code, response));
  }
}

export default function* workflowsApi() {
  yield takeEvery([actions.FETCH_WORKFLOWS, actions.REFRESH_WORKFLOWS], workflows);
  yield takeEvery(actions.FETCH_WORKFLOW, workflow);
}
